<div class="flex flex--row flex--nowrap flex--left flex--stretch text-14 to-do-count">
  <!-- STAT Count -->
  <div *ngIf="counts.stat" id="stat-count"
       class="stat text-align--base-center">
    {{counts.stat > 99 ? '99+' : counts.stat}}
  </div>

  <!-- Total Count -->
  <div id="total-count"
       class="u-pr---- total text-align--base-center" [ngClass]="{'no-stat': !counts.stat}">
    {{counts.total > 500 ? '500+' : counts.total}}
  </div>

  <!-- AI Indicator -->
  <div *ngIf="showFindings && counts.findings > 0"
       class="findings">
    <svg-icon name="ico-ai-16"
              [svgStyle]="{ 'height.px': '16', 'width.px': '16' }">
    </svg-icon>
  </div>
</div>
